// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N0, N20, N40, Y50, Y75 } from '@atlaskit/theme/colors';
const lightYellow = `var(--ds-background-accent-yellow-subtlest, ${Y50})`;
const darkYellow = `var(--ds-background-accent-yellow-subtler, ${Y75})`;
const hoverWhite = `var(--ds-surface-raised-hovered, ${N20})`;
const white = `var(--ds-surface-raised, ${N0})`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FormCardContainer = styled.div`
	border-bottom: 1px solid ${`var(--ds-border, ${N40})`};
	padding: ${"var(--ds-space-025, 2px)"} 0;
	border-radius: 4px;

	background-color: ${props => props.isFormYellow ? lightYellow : white};

	&:hover {
		background-color: ${props => {
  if (props.formIsSelected) {
    return '';
  }
  return props.isFormYellow ? darkYellow : hoverWhite;
}};
	}

	&:first-child {
		border-radius: ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0 0;
	}

	&:last-child {
		border-radius: 0 0 ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"};
		border-bottom: 0;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FormBodyWrapper = styled.div({
  padding: "var(--ds-space-150, 12px)"
});